import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import JobList from "../components/jobs/JobList";
import { searched, sorted } from "../features/filter/filterSlice";

export default function AvailableJobs() {
	const { searchText, sort } = useSelector(state => state.filter);
	const [search, setSearch] = useState(searchText);
	const [sortBy, setSortBy] = useState(sort);
	
	const dispatch = useDispatch();

	const handleSearch = (value) => {
		setSearch(value);
		dispatch(searched(value));
	}

	const handleOrderBy = (value) => {
		setSortBy(value);
		dispatch(sorted(value));
	}

	return (
		<>
			<div className="md:flex space-y-2 md:space-y-0 justify-between mb-10 ">
				<h1 className="section-title">All Available Jobs</h1>
				<div className="flex gap-4">
					<div className="search-field group flex-1">
						<i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500"></i>
						<input
							value={search}
							onChange={(e) => handleSearch(e.target.value)}
							type="text"
							placeholder="Search Job"
							className="search-input"
							id="lws-searchJob"
						/>
					</div>
					<select
						value={sortBy}
						onChange={(e) => handleOrderBy(e.target.value)}
						id="lws-sort"
						name="sort"
						autoComplete="sort"
						className="flex-1"
					>
						<option value='Default'>Default</option>
						<option value='Salary_ASC'>Salary (Low to High)</option>
						<option value='Salary_DESC'>Salary (High to Low)</option>
					</select>
				</div>
			</div>

			<JobList />
		</>
	);
}
